<template>
  <Layout1>
    <div class="cateSettings">
    <div  class="cateSetting" v-for="k in Object.keys(mapping)" :key="k">
      <div>{{mappingName[k]}}
        <EditBtn :style="{marginLeft: 'auto', marginRight: '10px'}" @click="edit=k" v-if="edit!==k"/>
        <BtnsS :style="{marginLeft: 'auto', marginRight: '10px'}" v-else-if="edit===k"  @save="save" @cancel="edit=null"/>
      </div>
      <table class="cateTable">
        <thead><tr><th>類別</th><th>比例</th></tr></thead>
        <tbody v-if="edit===k">
          <tr v-for="(x, i) in rows" :key="`${k}-${i}`"><td><input type="text" v-model="rows[i].key"></td><td><input type="text"  v-model="rows[i].value"></td></tr>
          <tr><td><input type="text" v-model="key"></td><td><input type="text" v-model="value" @keypress.enter="pushto"></td></tr>
        </tbody>
        <tbody v-else-if="edit!==k">
          <tr v-for="(x, i) in datas[k]" :key="`${k}-${i}`"><td>{{x.key}}</td><td>{{x.value}}</td></tr>
        </tbody>
      </table>
    </div>
    <!-- <div  class="cateSetting">
      <div>餐廳</div>
      <table class="cateTable">
        <thead><tr><th>類別</th><th>比例</th></tr></thead>
        <tbody>
          <tr v-for="(x, i) in rests" :key="`rests-${i}`"><td>{{x.key}}</td><td>{{x.value}}</td></tr>
        </tbody>
      </table>
    </div>
    <div  class="cateSetting">
      <div>周晬禮讚</div>
      <table class="cateTable">
        <thead><tr><th>類別</th><th>比例</th></tr></thead>
        <tbody>
          <tr v-for="(x, i) in weddings" :key="`weddings-${i}`"><td>{{x.key}}</td><td>{{x.value}}</td></tr>
        </tbody>
      </table>
    </div>
    <div  class="cateSetting">
      <div>甜蜜佳緣</div>
      <table class="cateTable">
        <thead><tr><th>類別</th><th>比例</th></tr></thead>
        <tbody>
          <tr v-for="(x, i) in babies" :key="`babies-${i}`"><td>{{x.key}}</td><td>{{x.value}}</td></tr>
        </tbody>
      </table>
    </div>
    <div  class="cateSetting">
      <div>活動</div>
      <table class="cateTable">
        <thead><tr><th>類別</th><th>比例</th></tr></thead>
        <tbody>
          <tr v-for="(x, i) in events" :key="`events-${i}`"><td>{{x.key}}</td><td>{{x.value}}</td></tr>
        </tbody>
      </table>
    </div> -->
    </div>
  </Layout1>
</template>

<script>
import { getapi, postapi } from '../../store/fetch'
import Layout1 from '../../components/layout/L1.vue'
import EditBtn from '../../components/btn/edit.vue'
// import SaveBtn from '../../components/btn/save.vue'
export default {
  components: { Layout1, EditBtn },
  data () {
    return {
      datas: {
        teams: [],
        rests: [],
        weddings: [],
        babies: [],
        events: []
      },
      rows: [],
      edit: null,
      key: null,
      value: null,
      mapping: {
        teams: 'sourceTeam',
        rests: 'source',
        babies: 'sourceBaby',
        weddings: 'sourceWedding',
        events: 'sourceEvent'
      },
      mappingName: {
        teams: '園區',
        rests: '餐廳',
        babies: '周晬禮讚',
        weddings: '甜蜜佳緣',
        events: '活動'
      }
    }
  },
  async mounted () {
    this.datas.teams = await getapi('selections/sourceTeam')
    this.datas.rests = await getapi('selections/source')
    this.datas.weddings = await getapi('selections/sourceWedding')
    this.datas.babies = await getapi('selections/sourceBaby')
    this.datas.events = await getapi('selections/sourceEvent')
  },
  watch: {
    edit () {
      if (this.edit) {
        this.rows = JSON.parse(JSON.stringify(this.datas[this.edit]))
      } else {
        this.rows = []
      }
    }
  },
  methods: {
    async save () {
      if (this.key && this.value !== null && parseFloat(this.value)) {
        this.rows.push({ key: this.key, value: (parseFloat(this.value) || 0) })
        this.key = null
        this.value = null
      }
      const r = await postapi(`selections/${this.mapping[this.edit]}`, { key: 'optionsObj', data: this.rows.filter(e => e.key) })
      if (r) {
        this.datas[this.edit] = r
        this.edit = null
      }
    },
    pushto () {
      if (this.key && this.value !== null && parseFloat(this.value)) {
        this.rows.push({ key: this.key, value: (parseFloat(this.value) || 0) })
        this.key = null
        this.value = null
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.cateSettings {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 40px;
  gap: 30px;
}
.cateSetting {
  height: fit-content;
  &>div:nth-child(1) {
    font-size: 24px;
    color: var(--color-checked);
    text-align: start;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }
}
.cateTable {
  width: 400px;
  height: fit-content;
  border-collapse: collapse;
  td, th {
    font-size: 18px;
    letter-spacing: 1px;
  }
  td {
    height: 65px;
  }
  th {
    height: 40px;
    font-weight: 700;
  }
  thead {
    background-color: var(--color-bar);
  }
  tbody {
    overflow-y: hidden;
    input[type=text] {
      width: 150px;
      height: 40px;
      border-radius: 3px;
      border: 1px solid var(--color-border);
      text-align: center;
      font-size: 18px;
    }
  }
}
</style>
